module.exports = __webpack_public_path__ + "img/Convertible.bbbebf56.jpg";